
import React, { useState } from 'react';
import './ImageCarousel.css'; // Ensure this line imports your CSS file
import img1 from './images/IMG-7366.jpg';
import img2 from './images/IMG-7658.jpg';
import img3 from './images/IMG-7472.jpg';
import img4 from './images/IMG-7524.jpg';
import img5 from './images/IMG-7455.jpg';
import img6 from './images/IMG-7640-1.jpg';
import img7 from './images/IMG-7379.jpg';
import img8 from './images/Whats-App-Image-2026-03-14-at-8-12-15-PM.jpg';
import img9 from './images/IMG-7333.jpg';
import img10 from './images/IMG-7310.jpg';
import img11 from './images/IMG-7648.jpg';
import img12 from './images/Whats-App-Image-2026-03-14-at-8-12-16-PM.jpg';

const ImageCarousel = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12];

  const handleClick = (imgSrc) => {
    setSelectedImage(imgSrc);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };

  return (
    <div>
      <div className="px-5 grid grid-cols-1 md:grid-cols-3 gap-6 mb-5">
        {Array.from({ length: 3 }).map((_, colIndex) => (
          <div className="grid gap-4" key={colIndex}>
            {images.slice(colIndex * 4, colIndex * 4 + 4).map((imgSrc, imgIndex) => (
              <div key={imgIndex}>
                <img
                  className="ted-image h-auto w-full rounded-lg cursor-pointer"
                  src={imgSrc}
                  alt=""
                  onClick={() => handleClick(imgSrc)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>

      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
          onClick={handleClose} // Closes modal when clicking the dark background
        >
          {/* Moved the close button outside the image wrapper and made it fixed 
            so it stays perfectly in the top right corner of the screen.
          */}
          <button
            className="fixed top-4 right-6 md:top-8 md:right-10 z-[100] text-white text-5xl hover:text-red-500 transition-colors focus:outline-none"
            onClick={handleClose}
          >
            &times;
          </button>

          <div 
            className="relative px-4"
            onClick={(e) => e.stopPropagation()} // Prevents clicks on the actual image from closing the modal
          >
            <img
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
              src={selectedImage}
              alt="Zoomed In"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;



// import React, { useState } from 'react';
// import './ImageCarousel.css';

// const ImageCarousel = () => {
//   const data = [
//     { id: 1, imgSrc: 'https://i.ibb.co/pnbMVyP/Screenshot-2024-08-22-095823.png' },
//     { id: 2, imgSrc: 'https://i.ibb.co/Z2sSXr6/Screenshot-2024-08-22-095218.png' },
//     { id: 3, imgSrc: 'https://i.ibb.co/ySCDbNC/Screenshot-2024-08-22-095908.png' },
//     { id: 4, imgSrc: 'https://i.ibb.co/hHhmGZx/Screenshot-2024-08-22-095724.png' },
//     { id: 5, imgSrc: 'https://i.ibb.co/R3HC7LF/Screenshot-2024-08-26-225939.png' },
//     // https://i.ibb.co/LPJNw6t/Screenshot-2024-08-22-100019.png
//     { id: 6, imgSrc: 'https://i.ibb.co/b1WQZDp/Screenshot-2024-08-22-100959.png' },
//     { id: 7, imgSrc: 'https://live.staticflickr.com/65535/52768700661_5d6d983237_c.jpg' },
//     { id: 8, imgSrc: 'https://i.ibb.co/R2PLhXY/Screenshot-2024-08-22-100914.png' },
//     { id: 9, imgSrc: 'https://i.ibb.co/gSy7yxR/Screenshot-2024-08-22-095423.png' },
//     { id: 10, imgSrc: 'https://i.ibb.co/J7BmrG2/Screenshot-2024-08-22-102225.png' },
//     { id: 11, imgSrc: 'https://i.ibb.co/h15nqbQ/Screenshot-2024-08-22-102215.png' },
//     { id: 12, imgSrc: 'https://i.ibb.co/JFkQGNF/Screenshot-2024-08-22-102008.png' },
//     { id: 13, imgSrc: 'https://i.ibb.co/0r7cgnh/Screenshot-2024-08-22-102824.png' },
//   ];

//   const [model, setModel] = useState(false);
//   const [tempImgSrc, setTempImgSrc] = useState('');

//   const getImg = (imgSrc) => {
//     setTempImgSrc(imgSrc);
//     setModel(true);
//   };

//   const closeModel = () => {
//     setModel(false);
//   };

//   return (
//     <>
//       <div className={model ? 'ted-model ted-open' : 'ted-model'}>
//         <img src={tempImgSrc} alt="" />
//         <button className="ted-close-btn" onClick={closeModel}>X</button>
//       </div>
//       <div className="ted-gallery mt-5 mb-16">
//         {data.map((item, index) => (
//           <div className="ted-pics" key={index} onClick={() => getImg(item.imgSrc)}>
//             <img src={item.imgSrc} alt="" style={{ width: '100%' }} />
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

//export default ImageCarousel;

// import React, { useState } from 'react';
// import './ImageCarousel.css';


// const ImageCarousel = () => {

//   let data =[
//     {
//       id: 1,
//       imgSrc: 'https://i.ibb.co/pnbMVyP/Screenshot-2024-08-22-095823.png',
//     },
//     {
//       id: 2,
//       imgSrc: 'https://i.ibb.co/ySCDbNC/Screenshot-2024-08-22-095908.png',
//     },
//     {
//       id: 3,
//       imgSrc: 'https://i.ibb.co/LPJNw6t/Screenshot-2024-08-22-100019.png',
//     },
//     {
//       id: 4,
//       imgSrc: 'https://i.ibb.co/hHhmGZx/Screenshot-2024-08-22-095724.png',
//     },
//     {
//       id: 5,
//       imgSrc: 'https://i.ibb.co/Z2sSXr6/Screenshot-2024-08-22-095218.png',
//     },
//     {
//       id: 6,
//       imgSrc: 'https://i.ibb.co/b1WQZDp/Screenshot-2024-08-22-100959.png',
//     },
//     {
//       id: 7,
//       imgSrc: 'https://live.staticflickr.com/65535/52768700661_5d6d983237_c.jpg',
//     },
//     {
//       id: 8,
//       imgSrc: 'https://i.ibb.co/R2PLhXY/Screenshot-2024-08-22-100914.png',
//     },
//     {
//       id: 9,
//       imgSrc: 'https://i.ibb.co/gSy7yxR/Screenshot-2024-08-22-095423.png',
//     },
//     {
//       id: 10,
//       imgSrc: 'https://i.ibb.co/J7BmrG2/Screenshot-2024-08-22-102225.png',
//     },
//     {
//       id: 11,
//       imgSrc: 'https://i.ibb.co/h15nqbQ/Screenshot-2024-08-22-102215.png',
//     },
//     {
//       id: 12,
//       imgSrc: 'https://i.ibb.co/JFkQGNF/Screenshot-2024-08-22-102008.png',
//     },
//     {
//       id: 13,
//       imgSrc: 'https://i.ibb.co/0r7cgnh/Screenshot-2024-08-22-102824.png',
//     },
    


//   ]

//   const [model, setModel] = useState(false);
//   const [tempimgSrc, setTempImgSrc] = useState('');

//   const getImg = (imgSrc)=>
//   {
//      setTempImgSrc(imgSrc);
//      setModel(true);
//   }

//   return (
//     <>
//     <div className={model ? "model open" : "model"}>
//     <img src={tempimgSrc} alt="" />
//     </div>
//     <div className="gallery  mt-5 mb-16">
     
//      {data.map((item, index)=>
//      {
//        return(
//          <div className="pics" key={index}>
//            <img src={item.imgSrc} alt="" style={{width:"100%"}} />
//          </div>
//        )
//      })}
//     </div>
     
//     </>
//   )
// }

// export default ImageCarousel
